/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 内控审计弹框
 */

import { fieldAnomaly } from '../../../../../utils/formatter';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class InternalControlAudit extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '公司财务隐患概述';
    }

    getColumns = () => {
        return [{
            title: '结果',
            dataIndex: 'interconaudittype',
            width: 200
        }, {
            title: '结果说明',
            dataIndex: 'interconauditopin',
            render: fieldAnomaly
        }, {
            title: '审计机构',
            dataIndex: 'auditcompdom'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/InternalControlAudit.jsx